import { render, staticRenderFns } from "./Bordas.vue?vue&type=template&id=07f7512f"
import script from "./Bordas.vue?vue&type=script&lang=js"
export * from "./Bordas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports